import { render, staticRenderFns } from "./BroadcastRequestViewer.vue?vue&type=template&id=1bf00872&scoped=true"
import script from "./BroadcastRequestViewer.vue?vue&type=script&lang=js"
export * from "./BroadcastRequestViewer.vue?vue&type=script&lang=js"
import style0 from "./BroadcastRequestViewer.vue?vue&type=style&index=0&id=1bf00872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf00872",
  null
  
)

export default component.exports